import React from "react";

const ShippingOne = () => {
  return (
    <section
      className="shipping  d-lg-block d-none"
      id="shipping"
      style={{
        marginTop: "2.2rem",
        borderRadius: "0.4rem",
        background: "#faddbd",
      }}
    >
      <div className="container container-lg">
        <div className="row gy-4 ">
          <div className="col-xxl-3 col-sm-6">
            <div className=" flex-align justify-content-lg-center gap-16  mb-20  transition-2 ">
              <span className="w-48 h-48 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                <i className="ph-fill ph-car-profile" />
              </span>
              <div className="">
                <h6 className=" text-md mb-0">Free Delievery</h6>
                <span className="text-xs text-heading ">
                  All the time free Delievery
                </span>
              </div>
            </div>
          </div>
          <div className="col-xxl-3 col-sm-6 ">
            <div className=" flex-align justify-content-lg-center gap-16  mb-20  transition-2">
              <span className="w-48 h-48 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                <i className="ph-fill ph-credit-card" />
              </span>
              <div className="">
                <h6 className=" text-md mb-0"> Secure transaction</h6>
                <span className="text-xs text-heading ">
                  Checkout Securely & Cash on Delievery{" "}
                </span>
              </div>
            </div>
          </div>
          <div className="col-xxl-3 col-sm-6 ">
            <div className=" flex-align justify-content-lg-center gap-16   mb-20  transition-2">
              <span className="w-48 h-48 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                <i className="ph-fill ph-chats" />
              </span>
              <div className="">
                <h6 className=" text-md mb-0"> 24/7 Support</h6>
                <span className="text-xs text-heading ">
                  Ready to pickup calls
                </span>
              </div>
            </div>
          </div>
          <div className="col-xxl-3 col-sm-6 ">
            <div className=" flex-align justify-content-lg-center  gap-16  mb-20  transition-2">
              <span className="w-48 h-48 flex-center rounded-circle bg-main-600 text-white text-32 flex-shrink-0">
                <i className="ph-fill ph-hand-heart" />
              </span>
              <div className="">
                <h6 className="text-md mb-0"> Sales & Discounts offer</h6>
                <span className="text-xs text-heading ">On many products</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShippingOne;
